/**
 * @flow
 * @relayHash b69c9b2ad1fabc5e2bb3a9a79a24c80e
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CountryUpdateInput = {|
  id: string,
  name: string,
|};
export type UpdateCountryMutationVariables = {|
  data: CountryUpdateInput
|};
export type UpdateCountryMutationResponse = {|
  +updateCountry: {|
    +id: string
  |}
|};
export type UpdateCountryMutation = {|
  variables: UpdateCountryMutationVariables,
  response: UpdateCountryMutationResponse,
|};
*/


/*
mutation UpdateCountryMutation(
  $data: CountryUpdateInput!
) {
  updateCountry(data: $data) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "data",
    "type": "CountryUpdateInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateCountry",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "data",
        "variableName": "data"
      }
    ],
    "concreteType": "CountryModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateCountryMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateCountryMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateCountryMutation",
    "id": null,
    "text": "mutation UpdateCountryMutation(\n  $data: CountryUpdateInput!\n) {\n  updateCountry(data: $data) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '9cd83b4d0c3c6653a4f81e5910a2ca09';
module.exports = node;
